
import Vue from 'vue';
import api from '@/rest-api';
import { SearchResult } from '@/model';
import { RouteNames } from '@/router/route-names';

const resultTypes = ['ingest', 'fragment'];
type ResultTypes = typeof resultTypes[number];
export default Vue.extend({
  name: 'Searchbar',

  data() {
    return {
      query: undefined as string | undefined,
      activeTab: 0,
      typedResults: [] as Array<{ type: ResultTypes; waiting: boolean; results: SearchResult[] }>,
    };
  },

  methods: {
    search() {
      this.typedResults = [];
      this.activeTab = 0;
      if (this.query) {
        const q = this.query;
        resultTypes.forEach((type, i) => {
          this.typedResults.push({ type, waiting: true, results: [] });
          api.search(q, type).then((results) => Vue.set(this.typedResults, i, {
            type,
            waiting: false,
            results,
          })).catch(() => Vue.set(this.typedResults, i, {
            type,
            waiting: false,
            results: [],
          }));
        });
      }
    },
    showDocumentResult(result: SearchResult) {
      const params: Record<string, string> = {
        documentId: `${result.fileId}`,
        ingestId: `${result.ingestId}`,
      };
      if (result.fragmentId != null) {
        params.scrollToFragmentId = `${result.fragmentId}`;
      }
      this.$router.push({ name: RouteNames.DocumentResult, params });
      this.close();
    },
    close() {
      this.typedResults = [];
    },
    clear() {
      this.query = undefined;
      this.typedResults = [];
    },
  },
});
